import Network from '../network.js'

export default {
  getVapidPublicKey() {
    return Network.get('/push/vapid-public-key', null, false)
  },
  subscribe(request) {
    return Network.post('/push/subscribe', request, true)
  },
  unsubscribe(request) {
    return Network.delete('/push/subscribe', request, true)
  },
  check(request) {
    return Network.get('/push/subscription', request, true)
  }
}
